<template>
  <header class="sticky-header">
    <header-top-vue />
    <header-bottom-vue :heading="currentYear" :specific-link="'APPOINTMENT'" />
  </header>
</template>

<script>
import HeaderTopVue from "../../common/HeaderTop.vue";
import HeaderBottomVue from "../../common/HeaderBottom";
import { mapActions } from "vuex";

export default {
  components: {
    HeaderTopVue,
    HeaderBottomVue
  },
  props: {
    currentYear: Number
  },
  methods: {
    ...mapActions("chat", {
      getDetails: "getDetails"
    })
  },
  created() {
    if (this.userRole === 22 || this.userRole === 25) {
      this.getDetails();
    }
  }
};
</script>

<style scoped>
.sticky-header {
  height: 97px !important;
}
</style>
